import { Component, Input, inject, OnInit, Signal, OnDestroy, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiIcon } from '@taiga-ui/core';
import { DesktopMenuComponent } from '../desktop-menu/desktop-menu.component';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MobileMenuComponent } from '../mobile-menu/mobile-menu.component';
import { APP_NAME, MOBILE_SCREEN_SIZE, ThemeMode } from '@ffx/common';
import { ApplicationStore, FlagStore, ProjectStore } from '@ffx/app-store';
import { LogoutComponent } from '../logout/logout.component';
import { filter, Subscription } from 'rxjs';

@Component({
    selector: 'ffx-header',
    standalone: true,
    imports: [CommonModule, TuiIcon, DesktopMenuComponent, MobileMenuComponent, RouterOutlet, LogoutComponent],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
    @Input() showMenu = true;
    @Input() showBackButton = true;

    private router = inject(Router);
    private appStore = inject(ApplicationStore);
    private flagStore = inject(FlagStore);
    private projectStore = inject(ProjectStore);
    private subscriptions = new Subscription();

    selectedProject$ = this.projectStore.selectedProject;
    theme$: Signal<ThemeMode> = signal('light');
    appTitle = APP_NAME;
    isMobile = false;
    isDashboard = true;
    projectId = '';

    // Can add any other loading statuses here to trigger the progress bar
    showProgressBar$ = computed(() => this.flagStore.publishFlagsLoading());

    constructor() {
        this.theme$ = this.appStore.user.theme;
    }

    ngOnInit(): void {
        this.checkScreenSize();
        window.addEventListener('resize', () => this.checkScreenSize());
        this.checkUrl(window.location.pathname.split('/')[1]); // To allow for a refresh on the page

        this.subscriptions.add(
            this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: any) => {
                const urlSegments = event.urlAfterRedirects.split('/');
                const newProjectId = urlSegments[1];
                this.checkUrl(newProjectId);
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    goBack(): void {
        this.router.navigate(['/']);
    }

    checkScreenSize(): void {
        this.isMobile = window.innerWidth <= MOBILE_SCREEN_SIZE;
    }

    checkUrl(newProjectId: string): void {
        if (newProjectId) {
            this.isDashboard = false;
        }
        if (newProjectId && newProjectId !== this.projectId) {
            this.projectId = newProjectId;
        } else if (newProjectId === '') {
            this.projectStore.resetProjectName();
        }
    }

    toggleDarkMode(): void {
        if (this.theme$() === 'dark') {
            this.appStore.setUserTheme('light');
        } else {
            this.appStore.setUserTheme('dark');
        }
    }
}
